import { useMemo } from "react";
import { useQueryEmployeeTaxFormsChecklist } from "../../../query/employeeTaxForms/queries/useQueryEmployeeTaxFormsChecklist";
import { selectorChecklistViewFromItems } from "../selectors/selectorChecklistViewFromItems";

/**
 * Shared data layer for both tax-form checklists — the standalone/onboarding
 * route screen and the inline requirement-page checklist. Loads the checklist,
 * orders it, and derives the completion summary in one place so the two views
 * can't drift on ordering or "all complete" semantics.
 */
export const useEmployeeTaxFormsChecklistView = (engagementId: string) => {
  const queryChecklist = useQueryEmployeeTaxFormsChecklist(engagementId);

  const { orderedItems, allCompleted, completedCount } = useMemo(
    () => selectorChecklistViewFromItems(queryChecklist.data?.items ?? []),
    [queryChecklist.data]
  );

  return {
    isLoading: queryChecklist.isLoading,
    orderedItems,
    allCompleted,
    completedCount
  };
};
